import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IoLanguage } from "react-icons/io5";
export const LocalizationPill = ({ children, selected = true })=>{
    if (selected) {
        return /*#__PURE__*/ _jsx(SelectedLocalizationPill, {
            children: children
        });
    }
    return /*#__PURE__*/ _jsx(UnselectedLocalizationPill, {
        children: children
    });
};
export const SelectedLocalizationPill = ({ children })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "text-[13px] !font-normal rounded-md  px-2 overflow-hidden flex flex-row items-center h-[24px] bg-brand-primary bg-opacity-7  border border-brand-primary border-opacity-10 text-brand-primary",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-row gap-1 items-center justify-center",
            children: [
                /*#__PURE__*/ _jsx(IoLanguage, {
                    size: 14
                }),
                children
            ]
        })
    });
};
export const UnselectedLocalizationPill = ({ children })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "text-xs rounded-md  pl-1 pr-1 overflow-hidden flex flex-row items-center h-[24px] font-mono  bg-grayscale-light bg-opacity-7  border border-white border-opacity-10 text-white",
        children: /*#__PURE__*/ _jsx("div", {
            className: "flex flex-col content-center justify-center transform scale-[0.8] xl:scale-[1]",
            children: children
        })
    });
};
export const LocalizedTextBox = ({ children })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "bg-grayscale-dark border border-white/10 rounded-md px-2 py-1 text-sm",
        children: children
    });
};
